import { Expose } from 'class-transformer';

import { DropdownModel } from './dropdown-model';

export class LookupModel extends DropdownModel {
  @Expose() id: string;
  @Expose() isChild: boolean;
  @Expose() isDataRequired: boolean;
  @Expose() level: string;
  @Expose() pathKey: string;
  @Expose() value: string;

  override get dropDownDisplayName(): string {
    return this.value;
  }
  override get dropDownValue(): Object {
    return this;
  }
}
